import gql from 'graphql-tag'

import BASE from './Base'

export default gql`
  fragment ParticipantWithFees on Participant {
    ...ParticipantBase
    fees
  }
  ${BASE}
`
